import {arrayIndex} from "@/core/util/arrayIndex";
import {useBasketStore} from "@/modules/shop/store/basket";
import {useBasketRulesStore} from "@/modules/shop/store/basket-rules";
import {useLoalityStore} from "@/modules/shop/store/loyalty";
import {useVorderState} from "@/modules/shop/store/vorder-state";
import {useVorderValidate} from "@/modules/shop/store/vorder-validate";
import {defineStore, storeToRefs} from "pinia";
import {computed} from "vue";
import {BasketItemCalculated} from "./util/benefit";
import {useDeliveryStore} from "@/modules/shop/store/delivery";

const STORE_NAME = "vorder-total";

export const useVorderTotalStore = defineStore(STORE_NAME, () => {
    const basketStore = useBasketStore();
    const basketRulesStore = useBasketRulesStore();
    const validateStore = useVorderValidate();
    const vorderStateStore = useVorderState()
    const loalityStore = useLoalityStore()
    const deliveryStore = useDeliveryStore()

    const {attrs} = storeToRefs(vorderStateStore);
    const {
        basketItemsBenefited,
        basketPriceDiscounted,
        deliveryPriceDiscounted
    } = storeToRefs(basketRulesStore);
    const {deliveryPrice} = storeToRefs(deliveryStore);
    const {basketPrice} = storeToRefs(basketStore);
    const {getBonusesMax} = loalityStore

    const errorByItem = computed(() => {
        return arrayIndex(validateStore.validateResult.filter(item => item.section === 'basket_item'), 'itemUuid')
    })

    const basketItemsCalculated = computed<BasketItemCalculated[]>(() => {
        return basketItemsBenefited.value.map(item => {
            const error = errorByItem.value[item.model.getUuid()]
            return {
                ...item,
                error
            }
        })
    });

    const basketItemsCalculatedById = computed(() =>
        arrayIndex(basketItemsCalculated.value, (item) => item.model.id)
    );

    const basketItemsCalculatedByProduct = computed(() =>
        arrayIndex(basketItemsCalculated.value, (item) => item.model.fields.PRODUCT_ID)
    );


    const orderPriceSource = computed(() => {
        return Math.round(basketPrice.value + deliveryPrice.value)
    });

    const pricePaySource = computed(() => {
        return orderPriceSource.value
    });

    const orderPrice = computed(() => Math.round(basketPriceDiscounted.value + deliveryPriceDiscounted.value));

    const pricePay = computed(() => orderPrice.value);

    const basketPriceTotal = computed(() => basketPriceDiscounted.value);

    const bonusesMax = computed(() => 0);

    // SYNC WITH SHARED STORE
    // Синхронизируем критические данные с shared store для избежания циклических зависимостей
    /*
    const sharedStore = useSharedStore();

    watch(orderPrice, (newValue) => {
        sharedStore.orderPriceTotal = newValue;
    }, {immediate: true});

    watch(basketPriceTotal, (newValue) => {
        sharedStore.basketPriceTotal = newValue;
    }, {immediate: true});

    watch(deliveryPrice, (newValue) => {
        sharedStore.deliveryPrice = newValue;
    }, {immediate: true});
*/
    return {
        pricePay,
        pricePaySource,
        orderPrice,
        basketPriceTotal,
        basketItemsCalculatedById,
        basketItemsCalculated,
        basketItemsCalculatedByProduct,
        deliveryPrice,
        bonusesMax,
    };
});
